import CryptoJS from "crypto-js";
import PropTypes from "prop-types";

const dbName = "designcloud-pfile";
const objectStoreName = "pfile";

const getDBVersion = async () => {
    const db = await openDB();
    const version = db.version || 1;
    return version;
};

// Open IndexedDB
const openDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName);

        request.onsuccess = () => {
            resolve(request.result);
        };

        request.onerror = () => {
            reject(request.error);
        };

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            const newVersion = event.newVersion || 1;
        };
    });
};

export const createStoreDatabase = async (data) => {
    // Increment the database version per use
    const dbVersion = (await getDBVersion()) + 1;
    const dbPromise = indexedDB.open(dbName, dbVersion);

    dbPromise.onupgradeneeded = (event) => {
        const db = event.target.result;

        if (!db.objectStoreNames.contains(objectStoreName)) {
            db.createObjectStore(objectStoreName, { keyPath: "key" });
        }
    };

    dbPromise.onsuccess = (event) => {
        const db = event.target.result;

        const transaction = db.transaction([objectStoreName], "readwrite");
        const objectStore = transaction.objectStore(objectStoreName);
        const dataToStore = { key: "pricefile", value: data };

        transaction.onerror = (event) => {
            console.error("Transaction error:", event.target.error);
        };

        objectStore.put(dataToStore);

        transaction.oncomplete = () => {
            
        };
    };

    dbPromise.onerror = (event) => {
        console.error("Error opening database:", event.target.error);
    };
};

export const getStoreDatabase = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            const dbVersion = await getDBVersion();
            if (dbVersion > 1) {
                const db = await indexedDB.open(dbName, dbVersion);

                db.onsuccess = () => {
                    if (!db?.result?.objectStoreNames.length > 0) return;
                    const transaction = db.result.transaction([objectStoreName], "readonly");
                    const objectStore = transaction.objectStore(objectStoreName);
                    const getRequest = objectStore.get("pricefile");

                    getRequest.onsuccess = () => {
                        const data = getRequest.result;
                        
                        resolve(data ? data.value : null);
                    };

                    getRequest.onerror = (error) => {
                        console.error("Error retrieving data:", error);
                        reject(error);
                    };
                };

                db.onerror = (error) => {
                    console.error("Error opening database:", error);
                    reject(error);
                };
            } else {
                resolve(null);
            }
        } catch (error) {
            console.error("Error opening database:", error);
            reject(error);
        }
    });
};

export function decryptData(encryptedData, ivBase64, encryptionKey) {
    try {
        const ivBytes = CryptoJS.enc.Base64.parse(ivBase64);

        const decrypted = CryptoJS.AES.decrypt(
            {
                ciphertext: CryptoJS.enc.Base64.parse(encryptedData),
            },
            CryptoJS.enc.Utf8.parse(encryptionKey),
            {
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                iv: ivBytes,
            }
        );

        const decryptedText = CryptoJS.enc.Utf8.stringify(decrypted);

        return decryptedText;
    } catch (error) {
        console.error("Decryption error:", error);
        throw error;
    }
}

createStoreDatabase.propTypes = {
    data: PropTypes.string.isRequired,
};
